// eslint-disable-next-line import/prefer-default-export
export var SCHEDULES_TRANSLATIONS = {
    schedules: {
        banner: {
            requeriments: 'Requisitos básicos',
            description: 'Es necesario disponer del mínimo de horas para un buen resultado',
            missingHours: 'Faltan <b> {{missingHours}} horas </b> para el tiempo mínimo de funcionamiento',
            mediumRequeriments: '¡Ya casi terminas! ',
            mediumDescription: 'Sólo quedan unas horas más para cumplir con los requisitos',
            successRequeriments: 'Horas mínimas listas!',
            successDescription: 'Requisitos cumplidos, se puede avanzar o registrar más horas',
            successHours: 'Ya lograste el <b>mínimo de horas</b>, puedes avanzar!',
            tip: '<b>Tip:</b> Puedes registrar más de {{minHours}} horas, pero es el mínimo ideal para operar',
            hoursRegister: '{{hours}} horas',
            labelRegister: 'Horas Registradas',
        },
        listWeek: {
            days: {
                mon: 'Lunes',
                tue: 'Martes',
                wed: 'Miércoles',
                thu: 'Jueves',
                fri: 'Viernes',
                sat: 'Sábado',
                sun: 'Domingo',
            },
            prefixDay: {
                mon: 'L',
                tue: 'M',
                wed: 'M',
                thu: 'J',
                fri: 'V',
                sat: 'S',
                sun: 'D',
            },
            startTime: 'Defina hora inicial',
            endTime: 'Defina hora final',
            repetHour: 'Hora ya registrada',
            closeStore: 'Tienda cerrada',
            technicalError: 'Hubo un problema técnico, no pudimos guardar los horarios. Vuelve a intentarlo en unos minutos',
            errorScheduleLess: 'Horario es menor al inicial',
            replace: 'Remplazar horarios',
            confirm: '¿Está seguro de que desea <br> reemplazar los tiempos de los <br> días ya registrados?',
            okConfirm: 'Si, reemplazar',
        },
        daysWeek: {
            config: 'Configura tus horarios',
            hoursSelect: 'Selecciona los días de la semana en que tu tienda funcionará',
        },
        copy: {
            copies: 'Copiar horarios a...',
            clean: 'Limpiar',
            apply: 'Aplicar',
            success: 'Copiado correctamente',
        },
        remove: {
            delete: 'Eliminar',
            success: 'Eliminado correctamente',
            error: 'Hubo un problema al eliminar el horario',
            cancel: 'Cancelar',
            undo: 'Deshacer',
            confirm: '¿Está seguro de que desea  eliminar los horarios de los  {{day}}? Perderás todos los  horarios configurados para ese  día.',
        },
    },
};
